import { ErrorTypes } from "@wix/form-validator";
const validateBirthdate = ({
  value,
  target
}) => {
  if (!value) {
    return void 0;
  }
  const date = new Date(value);
  if (date.getFullYear() < 1900) {
    return {
      errorPath: target,
      errorType: ErrorTypes.MIN_VALUE_ERROR,
      errorMessage: ""
    };
  }
  if (date.getTime() > Date.now()) {
    return {
      errorPath: target,
      errorType: ErrorTypes.MAX_VALUE_ERROR,
      errorMessage: ""
    };
  }
  return void 0;
};
export {
  validateBirthdate
};
//# sourceMappingURL=contacts-birthdate-validation.js.map
